interface NavLink {
  name: string;
  href: string;
  icon?: React.FC<{ className: string }>;
}

export const quickLinks: NavLink[] = [
  {
    name: 'About us',
    href: '/about-us',
  },
  {
    name: 'Contact us',
    href: '/contact-us',
  },
  {
    name: 'FAQs',
    href: '/faqs',
  },
  {
    name: 'Privacy Policy',
    href: '/privacy-policy',
  },
  {
    name: 'Terms & Conditions',
    href: '/terms-and-conditions',
  },
];
